import Login from "./AuthPages/Login/Index";
import SignUp from "./AuthPages/Signup/Index";
import ForgotPassword from "./AuthPages/forgotPassword/Index";
import BookingRequest from "./SideTabPages/Booking/bookingRequest";
import BookingDetail from "./SideTabPages/Booking/Detail";
import AboutUs from "./SideTabPages/Content/Aboutus";
import Faq from "./SideTabPages/Content/Faq";
import HelpSupport from "./SideTabPages/Content/HelpSupport";
import PrivacyPolicy from "./SideTabPages/Content/PrivacyPolicy";
import TermsCondition from "./SideTabPages/Content/TermsCondition";
import Dashboard from "./SideTabPages/Dashboard";
import DriverPayout from "./SideTabPages/DriverPayout";
import DriverPayoutDetail from "./SideTabPages/DriverPayout/Detail";
import ManageDriver from "./SideTabPages/ManageDriver";
import AddDriver from "./SideTabPages/ManageDriver/Add";
import DriverDetail from "./SideTabPages/ManageDriver/Detail";
import ManageService from "./SideTabPages/ManageService";
import MyProfile from "./SideTabPages/Setting/MyProfile";
import PaymentMethod from "./SideTabPages/Setting/PaymentMethod";
import AddPaymentMethod from "./SideTabPages/Setting/PaymentMethod/add/AddPaymentMethod";
import Wallet from "./SideTabPages/Setting/Wallet";
import TransactionHistory from "./SideTabPages/TransactionHistory";
import Earnings from "./SideTabPages/earning";
import MyBookings from "./SideTabPages/Booking/myBookings";
import GetAssignDriver from "./SideTabPages/GetAssignDriver";
import DriverAssignComp from "./SideTabPages/Booking/Detail/driverassign";
import ManageBooking from "./SideTabPages/ManageBooking";
import ManageBookingDetail from "./SideTabPages/ManageBooking/BookingDetail";
import MyGuestBookings from "./SideTabPages/ManageBooking/GuestBooking";
import GuestBookingDetail from "./SideTabPages/ManageBooking/GuestBooking/bookingDetail";

export const routes = [
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/signup", component: <SignUp /> },
];

export const privateRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/setting/profile", component: <MyProfile /> },
  { path: "/setting/payment-method", component: <PaymentMethod /> },
  { path: "/setting/payment-method/add", component: <AddPaymentMethod /> },
  { path: "/setting/wallet", component: <Wallet /> },
  { path: "/content/terms-condition", component: <TermsCondition /> },
  { path: "/content/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/content/about", component: <AboutUs /> },
  { path: "/content/help-support", component: <HelpSupport /> },
  { path: "/content/faq", component: <Faq /> },
  { path: "/transaction-history", component: <TransactionHistory /> },
  { path: "/earnings", component: <Earnings /> },
  { path: "/driver-payout", component: <DriverPayout /> },
  { path: "/driver-payout/detail", component: <DriverPayoutDetail /> },
  { path: "/manage-driver", component: <ManageDriver /> },
  { path: "/manage-driver/add", component: <AddDriver /> },
  { path: "/manage-driver/edit/:id", component: <AddDriver /> },
  { path: "/manage-driver/detail/:id", component: <DriverDetail /> },
  { path: "/manage-service", component: <ManageService /> },
  { path: "/booking/booking-request", component: <BookingRequest /> },
  { path: "/booking/my-bookings", component: <MyBookings /> },
  { path: "/booking-request/detail/:id", component: <BookingDetail /> },
  { path: "/myguest-booking", component: <MyGuestBookings /> },
  { path: "/myguest-booking/detail/:id", component: <GuestBookingDetail /> },
  // { path: "/my-bookings/detail/:id", component: < BookingDetail/> },
  { path: "/my-bookings/detail/:id", component: <DriverAssignComp /> },
  { path: "/assign-driver", component: <GetAssignDriver /> },
  { path: "/manage-booking", component: <ManageBooking /> },
  { path: "/manage-booking/detail/:id", component: <ManageBookingDetail /> },
];
